// --- Helper function to handle the opacity effect ---
const fadeButton = (button) => {
  if (!button) return;

  button.style.transition = 'none';
  button.style.opacity = '0';

  setTimeout(() => {
    button.style.transition = 'opacity 0.3s ease-in-out';
    button.style.opacity = '';

    setTimeout(() => {
      button.style.transition = '';
    }, 300);
  }, 400);
};
// ---------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {

  const sidebarToggles = document.querySelectorAll('.js-sidebar-toggle');
  const allWidgets = document.querySelectorAll('[class*="__sidebar-widget"]');
  const handleResize = () => {
    if (window.innerWidth < 1024) {
      allWidgets.forEach(widget => widget.classList.remove('is-open'));
    }
  };

  handleResize();

  window.addEventListener('resize', handleResize);

  sidebarToggles.forEach(toggle => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const parentWidget = this.closest('[class*="__sidebar-widget"]');

      if (parentWidget) {
        const isOpen = parentWidget.classList.contains('is-open');

        if (isOpen) {
          // If the widget is open, your logic closes ALL open widgets.
          // We loop through to find any open widget, close it, and fade its specific button.
          allWidgets.forEach(widget => {
            if (widget.classList.contains('is-open')) {
              widget.classList.remove('is-open');

              // Find and fade the button for this specific closing widget
              const associatedButton = widget.querySelector('.js-sidebar-toggle');
              fadeButton(associatedButton);
            }
          });
        } else {
          // If the widget is closed, open it and fade just the button you clicked
          parentWidget.classList.add('is-open');
          fadeButton(this);
        }
      }
    });
  });

  document.addEventListener('click', function (e) {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (isMobile) {
      allWidgets.forEach(widget => {
        // If clicking outside an open widget...
        if (widget.classList.contains('is-open') && !widget.contains(e.target)) {
          widget.classList.remove('is-open');

          // TRIGGER 2: Find the button inside the closing widget and apply the fade effect
          const associatedButton = widget.querySelector('.js-sidebar-toggle');
          fadeButton(associatedButton);
        }
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // 1. Find the TOC wrapper
  const tocWrapper = document.getElementById('toc');
  if (!tocWrapper) return;

  const headings = document.querySelectorAll('[data-include-in-toc="true"]');
  if (headings.length === 0) {
    tocWrapper.style.display = 'none';
    return;
  }

  const tocList = document.createElement('ul');
  tocList.className = 'toc-list';

  // Set up the Intersection Observer ---
  // This creates a "sensor box" on the screen.
  // rootMargin adjusts the top by -130px (to account for your sticky header/offset)
  // and ignores the bottom 60% of the screen so it only triggers when reading near the top.
  const observerOptions = {
    root: null,
    rootMargin: '-130px 0px -60% 0px',
    threshold: 0,
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      // When a heading enters our target zone
      if (entry.isIntersecting) {
        // 1. Remove the 'active' class from ALL TOC items
        document.querySelectorAll('.toc-item').forEach(function(item) {
          item.classList.remove('active');
        });

        // 2. Find the corresponding link for this heading and add 'active'
        const activeId = entry.target.id;
        const activeLink = document.querySelector(`.toc-link[href="#${activeId}"]`);
        if (activeLink) {
          activeLink.closest('.toc-item').classList.add('active');
        }
      }
    });
  }, observerOptions);
  // ---------------------------------------------

  // 2. Loop through headings and build the links
  headings.forEach(function(heading, index) {
    if (!heading.id) {
      heading.id = 'toc-heading-' + index;
    }

    const titleText = heading.innerText || heading.textContent;
    const summaryText = heading.getAttribute('data-toc-summary');
    const numberText = String(index + 1).padStart(2, '0') + '.';

    const listItem = document.createElement('li');
    listItem.className = 'toc-item';

    const anchor = document.createElement('a');
    anchor.href = '#' + heading.id;
    anchor.className = 'toc-link';

    // Smooth Scroll Logic
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const targetElement = document.getElementById(heading.id);

      if (targetElement) {
        const scrollOffset = 120;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - scrollOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });

        // Close sidebar on mobile after clicking
        const isMobile = window.matchMedia('(max-width: 1024px)').matches;

        if (isMobile) {
          const allWidgets = document.querySelectorAll('[class*="__sidebar-widget"]');

          allWidgets.forEach(widget => {
            if (widget.classList.contains('is-open')) {
              widget.classList.remove('is-open');
              const associatedButton = widget.querySelector('.js-sidebar-toggle');
              fadeButton(associatedButton);
            }
          });
        }
      }
    });

    // Create inner elements
    const numberEl = document.createElement('span');
    numberEl.className = 'toc-number';
    numberEl.textContent = numberText;

    const contentWrapper = document.createElement('div');
    contentWrapper.className = 'toc-content';

    const titleEl = document.createElement('span');
    titleEl.className = 'toc-title';
    titleEl.textContent = titleText;
    contentWrapper.appendChild(titleEl);

    if (summaryText && summaryText.trim() !== '') {
      const descEl = document.createElement('span');
      descEl.className = 'toc-description';
      descEl.textContent = summaryText;
      contentWrapper.appendChild(descEl);
    }

    anchor.appendChild(numberEl);
    anchor.appendChild(contentWrapper);
    listItem.appendChild(anchor);
    tocList.appendChild(listItem);

    // Tell the observer to watch this specific heading ---
    observer.observe(heading);
  });

  // 3. Inject into the wrapper
  tocWrapper.appendChild(tocList);
});

// About the Company button animation
document.addEventListener("DOMContentLoaded", () => {
  const actionBoxes = document.querySelectorAll('.sk-action-box');

  // 1. Handle clicks ON the icon
  actionBoxes.forEach(box => {
    const icon = box.querySelector('.sk-action-box__icon');

    if (icon) {
      icon.addEventListener('click', () => {
        if (window.innerWidth <= 1024) {
          box.classList.toggle('is-active');
        }
      });
    }
  });

  // 2. Handle clicks OUTSIDE the boxes
  document.addEventListener('click', (event) => {
    if (window.innerWidth <= 1024) {
      actionBoxes.forEach(box => {
        if (!box.contains(event.target)) {
          box.classList.remove('is-active');
        }
      });
    }
  });
});

// Measures the exact width of the window, ignoring the scrollbar
const updateTrueVw = () => {
  document.documentElement.style.setProperty('--true-vw', `${document.documentElement.clientWidth}px`);
};

window.addEventListener('resize', updateTrueVw);
updateTrueVw(); // Run once on load
